<template>
  <div class="row">
    <div class="col-md-9 narrowContainer">
      <UserPublicInfoEdit
        @syncUser="userKey = Math.random()"
      ></UserPublicInfoEdit>
      <ConnectWechat></ConnectWechat>
      <el-divider><i class="el-icon-lock"></i></el-divider>
      <ChangePassword></ChangePassword>
      <el-divider><i class="el-icon-warning-outline"></i></el-divider>
      <el-popconfirm
        confirm-button-text="确定注销"
        cancel-button-text="不注销"
        @confirm="deleteUser"
        title="确定注销账户？如需要恢复账户请联系hello@99huaren.com"
      >
        <el-button slot="reference" class="delete-button">注销账户</el-button>
      </el-popconfirm>
    </div>
    <div class="col-md-3">
      <h6>我的公开信息预览</h6>
      <UserSidebar v-if="user" :key="userKey" :id="user.id"></UserSidebar>
    </div>
  </div>
</template>

<script>
import UserSidebar from "../components/UserSidebarComponent.vue";
import UserPublicInfoEdit from "./UserPublicInfoEdit";
import { mapState } from "vuex";
import ConnectWechat from "./ConnectWechat";
import ChangePassword from "./ChangePassword";

export default {
  data() {
    return {
      userKey: Math.random()
    };
  },
  computed: {
    ...mapState(["user"])
  },
  components: {
    ConnectWechat,
    ChangePassword,
    UserPublicInfoEdit,
    UserSidebar
  },
  methods: {
    deleteUser: function() {
      this.$axios.delete("/user/archive").then(() => {
        this.$store.dispatch("logout");
        this.$message({
          type: "success",
          showClose: true,
          message: "成功注销账户！"
        })
      });
    }
  }
};
</script>

<style scoped>
.delete-button {
  width: 100%;
  background-color: var(--color-danger-emphasis);
}
</style>
